import React from 'react';
import styles from './ToggleButton.module.scss';
import { Icon } from 'components';
import { icons } from 'assets';

interface Props {
  switchedOn: boolean;
  loading?: boolean;
  needSync?: boolean;
  onClick: () => void;
  size?: 'standard' | 'mini';
}

const ToggleButton = (props: Props) => {
  const { switchedOn, onClick, loading = false, needSync = false, size = 'standard' } = props;
  // const toggleStyles = [styles.toggle];
  // mini && toggleStyles.push(styles.miniToggle);

  return (
    <div
      className={styles[`container--${size}`]}
      onClick={onClick}
    >

      <div
        className={styles.backEllipse}
        style={{
          background: switchedOn
            ? styles.blue
            : styles.borderGrey
        }}
      />

      <div
        className={styles[`toggle--${size}`]}
        style={switchedOn
          ? { right: 0 }
          : { left: 0 }
        }
      >
        {loading
          ? <Icon icon={icons.circleArrow} className={styles.loadingIcon} />
          : needSync
            ? <Icon icon={icons.syncArrows} />
            : null
        }
      </div>

    </div>
  );
};

export default ToggleButton;
